import fontSizes from "assets/stylesheets/modules/typography/font-sizes.module.scss";

const styles = {
  global: {
    ":root, body": {
      fontSize: fontSizes.md,
      color: "gray.700",
    },
    "h1, h2, h3, h4, h5, h6": {
      color: "gray.800",
    },
    strong: {
      color: "gray.800",
    },
    "*::placeholder": {
      color: "gray.400",
    },
    "ul, ol": {
      paddingLeft: "0",
    },
  },
};

export default styles;
